import React from "react";
import { FacialRecognition } from "../../components";

export default function Home() {
  return (
    <div>
      <FacialRecognition />
    </div>
  );
}
